import ShoppingBagAdd from "@ingka/ssr-icon/paths/shopping-bag-add";

const MultiAddOnIconPath = ShoppingBagAdd;

export default MultiAddOnIconPath;
